// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  margin: 0;
  padding: 0;
  outline: none;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
}

.content {
  text-align: center;
  margin-top: 80px;
}

.content h2.header {
  font-size: 18vw;
  line-height: 1em;
  position: relative;
}

.content h2.header:after {
  position: absolute;
  content: attr(data-text);
  top: 0;
  left: 0;
  right: 0;
  background: -webkit-repeating-linear-gradient(
    -45deg,
    #33B0FF,
    #33B0FF,
    #33B0FF,
    #33B0FF,
    #33B0FF,
    #33B0FF,
    #33B0FF
  );
  background-size: 400%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.25);
  animation: animate 10s ease-in-out infinite;
}

.content h4 {
  font-size: 1.5em;
  margin-bottom: 50px;
  text-transform: uppercase;
  color: #000;
  font-size: 2em;
   max-width: 600px; 
  position: relative;
  margin: 0 auto; 
}
.content p {
  font-size: 1.2em;
  color: #0d0d0d;
}
.content .btns {
  display: flex;
  align-items: center;
  margin: 55px 0;
  width: 8%;
  margin-left: 48%;
  justify-content: center; 
  background-color: #33B0FF;
   transition: background-color 0.3s; 
   border: 1px solid #43adf7;
   border-radius: 6px; 
}
 
.content .btns:hover {
  background-color: #048df0;
}`, "",{"version":3,"sources":["webpack://./src/components/styles.css"],"names":[],"mappings":"AACA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,MAAM;EACN,OAAO;EACP,QAAQ;EACR;;;;;;;;;GASC;EACD,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;EACpC,kDAAkD;EAClD,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc;GACb,gBAAgB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;GACxB,iCAAiC;GACjC,yBAAyB;GACzB,kBAAkB;AACrB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Poppins:400,500,600,700&display=swap');\n*{\n  margin: 0;\n  padding: 0;\n  outline: none;\n  box-sizing: border-box;\n  font-family: 'Poppins', sans-serif;\n}\n\n.content {\n  text-align: center;\n  margin-top: 80px;\n}\n\n.content h2.header {\n  font-size: 18vw;\n  line-height: 1em;\n  position: relative;\n}\n\n.content h2.header:after {\n  position: absolute;\n  content: attr(data-text);\n  top: 0;\n  left: 0;\n  right: 0;\n  background: -webkit-repeating-linear-gradient(\n    -45deg,\n    #33B0FF,\n    #33B0FF,\n    #33B0FF,\n    #33B0FF,\n    #33B0FF,\n    #33B0FF,\n    #33B0FF\n  );\n  background-size: 400%;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.25);\n  animation: animate 10s ease-in-out infinite;\n}\n\n.content h4 {\n  font-size: 1.5em;\n  margin-bottom: 50px;\n  text-transform: uppercase;\n  color: #000;\n  font-size: 2em;\n   max-width: 600px; \n  position: relative;\n  margin: 0 auto; \n}\n.content p {\n  font-size: 1.2em;\n  color: #0d0d0d;\n}\n.content .btns {\n  display: flex;\n  align-items: center;\n  margin: 55px 0;\n  width: 8%;\n  margin-left: 48%;\n  justify-content: center; \n  background-color: #33B0FF;\n   transition: background-color 0.3s; \n   border: 1px solid #43adf7;\n   border-radius: 6px; \n}\n \n.content .btns:hover {\n  background-color: #048df0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
